// tslint:disable:jsx-no-multiline-js
import * as React from 'react';

import * as CommonUx from '@abb/common-ux';
import { ContactForm, IAnalysisContactForm, ICountry } from '@module/shared';
import { FetchCountries } from '@service/CountryService';
import { UploadSparePartsDetailsService } from '@service/UploadSparePartsDetailsService';
import { AdditionalQuestions } from './AdditionalQuestions';
import { ContactInformation } from './ContactInformation';
import { Footer } from './Footer';
import { Header } from './Header';

import './RequestModal.scss';

interface IRequestModalProps {
  sparePartsUploadID: string;
  isOpen: boolean;
  dispatch: any;
  history: any;
  onClose: () => void;
}

interface IRequestModalState {
  requestInformation: IAnalysisContactForm;
  userAcceptsTerms: boolean;
  currentStepIndex: number;
  isCurrentStepValid: boolean;
  //Contact Information component
  validationStateName: CommonUx.VALIDATION_STATE;
  validationStateEmail: CommonUx.VALIDATION_STATE;
  validationStateConfirmEmail: CommonUx.VALIDATION_STATE;
  validationStateCompany: CommonUx.VALIDATION_STATE;
  validationStateLocation: CommonUx.VALIDATION_STATE;
  validationStateCountry: CommonUx.VALIDATION_STATE;
  validationStatePhoneNumber: CommonUx.VALIDATION_STATE;
  validationStatePostalCode: CommonUx.VALIDATION_STATE;
  // Additional Questions component
  validationStateCondition: CommonUx.VALIDATION_STATE;
  validationStateDowntime: CommonUx.VALIDATION_STATE;
  validationStateStorage: CommonUx.VALIDATION_STATE;
  validationStateAwareness: CommonUx.VALIDATION_STATE;
  // Contact Information component
  errorMessageName: string;
  errorMessageEmail: string;
  errorMessageConfirmEmail: string;
  errorMessageCompany: string;
  errorMessageLocation: string;
  errorMessageCountry: string;
  errorMessagePhoneNumber: string;
  errorMessagePostalCode: string;
  // Additiona Questions component
  errroMessageCondition: string;
  errorMessageDowntime: string;
  errorMessageStorage: string;
  errorMessageAwareness: string;
  disableSubmit: boolean;
  countries: ICountry[];
}

export class RequestModal extends React.Component<IRequestModalProps, IRequestModalState> {
  readonly initialState: IRequestModalState;
  readonly errorMessageName = 'Contact Name is required and can be 255 characters or less';
  readonly errorMessageEmail = 'Email Address is required';
  readonly errorMessageCompany = 'Company Name is required and can be 255 characters or less';
  readonly errorMessageLocation = 'Location is required and can be 255 characters or less';
  readonly errorMessageCountry = 'Country is required';
  readonly errorMessagePhoneNumber = 'Phone Number can be 255 characters or less';
  readonly errorMessagePostalCode = 'Postal Code can be 20 characters or less';
  readonly errroMessageCondition = `'Do you know the condition and location of all of your spare parts?' is required`;
  readonly errorMessageDowntime = `'Have you had downtime from missing or failed parts?' is required`;
  readonly errorMessageStorage = `'Are your spare parts kept in sealed static bags and / or sealed boxes?' is required`;
  readonly errorMessageAwareness = `'Are you aware of all the options and programs ABB has available for spare parts?' is required`;
  readonly empty = '';

  constructor(props: IRequestModalProps) {
    super(props);
    this.state = {
      requestInformation: new ContactForm(),
      userAcceptsTerms: false,
      currentStepIndex: 0,
      isCurrentStepValid: false,
      validationStateName: 'none',
      validationStateEmail: 'none',
      validationStateConfirmEmail: 'none',
      validationStateCompany: 'none',
      validationStateLocation: 'none',
      validationStateCountry: 'none',
      validationStatePhoneNumber: 'none',
      validationStatePostalCode: 'none',
      validationStateCondition: 'none',
      validationStateDowntime: 'none',
      validationStateStorage: 'none',
      validationStateAwareness: 'none',
      errorMessageName: this.errorMessageName,
      errorMessageEmail: this.errorMessageEmail,
      errorMessageConfirmEmail: this.errorMessageEmail,
      errorMessageCompany: this.errorMessageCompany,
      errorMessageLocation: this.errorMessageLocation,
      errorMessageCountry: this.errorMessageCountry,
      errorMessagePhoneNumber: this.errorMessagePhoneNumber,
      errorMessagePostalCode: this.errorMessagePostalCode,
      errroMessageCondition: this.errroMessageCondition,
      errorMessageDowntime: this.errorMessageDowntime,
      errorMessageStorage: this.errorMessageStorage,
      errorMessageAwareness: this.errorMessageAwareness,
      disableSubmit: false,
      countries: []
    };
    this.initialState = this.state;
  }

  componentDidMount() {
    FetchCountries().then((countries: ICountry[]) => {
      this.setState({countries});
    });
  }

  componentDidUpdate(prevProps: Readonly<IRequestModalProps>, prevState: Readonly<IRequestModalState>, snapshot?: any): void {
    if (this.state.countries.length === 0) {
      FetchCountries().then((countries: ICountry[]) => {
        this.setState({countries});
      });
    }
  }

  render() {
    const contactInformation = (
      <ContactInformation
        name={this.state.requestInformation.contactName}
        email={this.state.requestInformation.contactEmail}
        confirmEmail={this.state.requestInformation.confirmContactEmail}
        company={this.state.requestInformation.companyName}
        phone={this.state.requestInformation.phoneNumber}
        location={this.state.requestInformation.location}
        postal={this.state.requestInformation.postalCode}
        country={this.state.requestInformation.country}
        countries={this.state.countries}
        validationStateName={this.state.validationStateName}
        validationStateEmail={this.state.validationStateEmail}
        validationStateConfirmEmail={this.state.validationStateConfirmEmail}
        validationStateCompany={this.state.validationStateCompany}
        validationStatePhoneNumber={this.state.validationStatePhoneNumber}
        validationStatePostalCode={this.state.validationStatePostalCode}
        validationStateLocation={this.state.validationStateLocation}
        validationStateCountry={this.state.validationStateCountry}
        errorMessageName={this.state.errorMessageName}
        errorMessageEmail={this.state.errorMessageEmail}
        errorMessageConfirmEmail={this.state.errorMessageConfirmEmail}
        errorMessageCompany={this.state.errorMessageCompany}
        errorMessagePhoneNumber={this.state.errorMessagePhoneNumber}
        errorMessagePostalCode={this.state.errorMessagePostalCode}
        errorMessageLocation={this.state.errorMessageLocation}
        onChangeInput={this.onChangeHandlerInput}
        onChangeCountry={this.onChangeHandlerCountry}
        onBlurName={this.onBlurHandlerName}
        onBlurEmail={this.onBlurHandlerEmail}
        onBlurConfirmEmail={this.onBlurHandlerConfirmEmail}
        onBlurCompany={this.onBlurHandlerCompany}
        onBlurPhoneNumber={this.onBlurHandlerPhoneNumber}
        onBlurPostalCode={this.onBlurHandlerPostalCode}
        onBlurLocation={this.onBlurHandlerLocation}
      />
    );
    const additionalQuestions = (
      <AdditionalQuestions
        condition={this.state.requestInformation.condition}
        downtime={this.state.requestInformation.downtime}
        storage={this.state.requestInformation.storage}
        awareness={this.state.requestInformation.awareness}
        email={this.state.requestInformation.contactEmail}
        validationStateCondition={this.state.validationStateCondition}
        validationStateDowntime={this.state.validationStateDowntime}
        validationStateStorage={this.state.validationStateStorage}
        validationStateAwareness={this.state.validationStateAwareness}
        onChangeCondition={this.onChangeHandlerCondition}
        onChangeDowntime={this.onChangeHandlerDowntime}
        onChangeStorage={this.onChangeHandlerStorage}
        onChangeAwareness={this.onChangeHandlerAwareness}
      />
    );
    const steps = [
      { header: <Header title='Contact Information' />, body: contactInformation},
      { header: <Header title='Additional Questions to Understand Your Needs' />, body: additionalQuestions}
    ];
    const footer = (
      <Footer
        isFirstStep={this.state.currentStepIndex === 0}
        isLastStep={this.state.currentStepIndex === steps.length - 1}
        onClickCancel={this.onClickHandlerCancel}
        onClickBack={this.onClickHandlerBack}
        onClickNext={this.onClickHandlerNext}
        onClickSubmit={this.onClickHandlerSubmit}
        isValid={this.state.isCurrentStepValid}
      />
  );

    return (
      <CommonUx.Modal
        header={steps[this.state.currentStepIndex].header}
        isOpen={this.props.isOpen}
        onClose={this.onClickHandlerCancel}
        footer={footer}
        modalClassName='request-modal'
      >
        <div className='row'>
          <div className='col-sm-12'>
            {steps[this.state.currentStepIndex].body}
          </div>
        </div>
      </CommonUx.Modal>
    );
  }
  
  // private methods
  resetForm = () => {
    this.setState(this.initialState);
  }

  tryValidateForm() {
    const errors: string[] = [];
    this.props.dispatch({ type: 'REMOVE_BANNER', banners: [CommonUx.Banner] });
    switch (this.state.currentStepIndex) {
      case 0:
        // Contact Information
        if (this.state.validationStateName !== 'valid') {
          errors.push(this.state.errorMessageName);
          if (this.state.validationStateName === 'none') {
            this.setState({validationStateName: 'invalid'});
          }
        }
        if (this.state.validationStateEmail !== 'valid') {
          errors.push(this.state.errorMessageEmail);
          if (this.state.validationStateEmail === 'none') {
            this.setState({validationStateEmail: 'invalid'});
          }
        }
        if (this.state.validationStateConfirmEmail !== 'valid') {
          errors.push(this.state.errorMessageConfirmEmail);
          if (this.state.validationStateConfirmEmail === 'none') {
            this.setState({validationStateConfirmEmail: 'invalid'});
          }
        }
        if (this.state.validationStateCompany !== 'valid') {
          errors.push(this.state.errorMessageCompany);
          if (this.state.validationStateCompany === 'none') {
            this.setState({validationStateCompany: 'invalid'});
          }
        }
        if (this.state.validationStatePhoneNumber === 'invalid') {
          errors.push(this.state.errorMessagePhoneNumber);
          this.setState({validationStatePhoneNumber: 'invalid'});
        }
        if (this.state.validationStateLocation !== 'valid') {
          errors.push(this.state.errorMessageLocation);
          if (this.state.validationStateLocation === 'none') {
            this.setState({validationStateLocation: 'invalid'});
          }
        }
        if (this.state.validationStateCountry !== 'valid') {
          errors.push(this.state.errorMessageCountry);
          if (this.state.validationStateCountry === 'none') {
            this.setState({validationStateCountry: 'invalid'});
          }
        }
        if (this.state.validationStatePostalCode === 'invalid') {
          errors.push(this.state.errorMessagePostalCode);
          this.setState({validationStatePostalCode: 'invalid'});    
        }
        break;
      case 1:
        // Additional Questions
        if (this.state.validationStateCondition !== 'valid') {
          errors.push(this.state.errroMessageCondition);
          if (this.state.validationStateCondition === 'none') {
            this.setState({validationStateCondition: 'invalid'});
          }
        }
        if (this.state.validationStateDowntime !== 'valid') {
          errors.push(this.state.errorMessageDowntime);
          if (this.state.validationStateDowntime === 'none') {
            this.setState({validationStateDowntime: 'invalid'});
          }
        }
        if (this.state.validationStateStorage !== 'valid') {
          errors.push(this.state.errorMessageStorage);
          if (this.state.validationStateStorage === 'none') {
            this.setState({validationStateStorage: 'invalid'});
          }
        }
        if (this.state.validationStateAwareness !== 'valid') {
          errors.push(this.state.errorMessageAwareness);
          if (this.state.validationStateAwareness === 'none') {
            this.setState({validationStateAwareness: 'invalid'});
          }
        }
      default:
        break;
    }
    
    if (errors.length > 0) {
      return false;
    }
    return true;
  }

  resetCurrentStepValidationState = () => {
    switch (this.state.currentStepIndex) {
      case 0:
        this.setState({isCurrentStepValid:
          this.state.validationStateName === 'valid' &&
          this.state.validationStateEmail === 'valid' &&
          this.state.validationStateConfirmEmail === 'valid' &&
          this.state.validationStateCompany === 'valid' &&
          this.state.validationStateLocation === 'valid' &&
          this.state.validationStateCountry === 'valid' &&
          this.state.validationStatePhoneNumber !== 'invalid' &&
          this.state.validationStatePostalCode !== 'invalid'
        });
        break;
      case 1:
        this.setState({ isCurrentStepValid: 
          this.state.validationStateCondition === 'valid' &&
          this.state.validationStateDowntime === 'valid' &&
          this.state.validationStateStorage === 'valid' &&
          this.state.validationStateAwareness === 'valid'
        });
      default:
        break;
    }

  }

  // Contact Information handlers
  onChangeHandlerInput = (event: React.ChangeEvent<any>) => {
  const target = event.target;
  const value = target.type === 'checkbox' ? target.checked : target.value;
  const name = target.name;
  const newValue = {};
  newValue[name] = value;
  this.setState({ requestInformation: { ...this.state.requestInformation, ...newValue } });
  }

  onChangeHandlerCountry = (opt: CommonUx.Option) => {
    const country: string = opt.value as string;
    this.setState({ requestInformation: { ...this.state.requestInformation, country}}, () => {
      if (this.state.requestInformation.country && this.state.requestInformation.country.trim() !== this.empty) {
        this.setState({validationStateCountry: 'valid', errorMessageCountry: this.empty}, this.resetCurrentStepValidationState);
        return;
      }
      this.setState({validationStateCountry: 'invalid', errorMessageCountry: this.errorMessageCountry}, this.resetCurrentStepValidationState);
    });
  }

  onBlurHandlerName = () => {
    const contactName = this.state.requestInformation.contactName.trim();
    if (contactName === this.empty || contactName.length > 255) {
      this.setState({validationStateName: 'invalid', errorMessageName: this.errorMessageName}, this.resetCurrentStepValidationState);
      return;
    }
    if (contactName.match(/[\[\\\^\$\.\|\?\*\+\(\)\@\%\&\~]/)) {
      this.setState({validationStateName: 'invalid', errorMessageName: 'Special characters not allowed'}, this.resetCurrentStepValidationState);
      return;
    }
    this.setState({validationStateName: 'valid', errorMessageName: this.empty}, this.resetCurrentStepValidationState);
  }

  onBlurHandlerEmail = () => {
    const email = this.state.requestInformation.contactEmail.trim();
    const confirmEmail = this.state.requestInformation.confirmContactEmail.trim();

    if (email === this.empty) {
      this.setState({validationStateEmail: 'invalid', errorMessageEmail: this.errorMessageEmail}, this.resetCurrentStepValidationState);
      return;
    }    
    if (!CommonUx.IsValidEmailAddress(email)) {
      this.setState({validationStateEmail: 'invalid', errorMessageEmail: 'Email Address is invalid'}, this.resetCurrentStepValidationState);
      return;
    }
    if ((email !== confirmEmail) && (confirmEmail !== '')) {
      this.setState({validationStateEmail: 'invalid', errorMessageEmail: 'Emails do not match. Please re-enter'}, this.resetCurrentStepValidationState);
      this.setState({validationStateConfirmEmail: 'invalid', errorMessageConfirmEmail: 'Emails do not match. Please re-enter'}, this.resetCurrentStepValidationState);
      return;
    } 
    if (confirmEmail !== '') {
      this.setState({validationStateConfirmEmail: 'valid', errorMessageConfirmEmail: this.empty}, this.resetCurrentStepValidationState);
    }
    this.setState({validationStateEmail: 'valid', errorMessageEmail: this.empty}, this.resetCurrentStepValidationState);
  }

  onBlurHandlerConfirmEmail = () => {
    const email = this.state.requestInformation.contactEmail.trim();
    const confirmEmail = this.state.requestInformation.confirmContactEmail.trim();

    if (confirmEmail === this.empty) {
      this.setState({validationStateConfirmEmail: 'invalid', errorMessageConfirmEmail: this.errorMessageEmail}, this.resetCurrentStepValidationState);
      return;
    }    
    if (!CommonUx.IsValidEmailAddress(confirmEmail)) {
      this.setState({validationStateConfirmEmail: 'invalid', errorMessageConfirmEmail: 'Email Address is invalid'}, this.resetCurrentStepValidationState);
      return;
    }
    if ((email !== confirmEmail) && email !== '') {
      this.setState({validationStateEmail: 'invalid', errorMessageEmail: 'Emails do not match. Please re-enter.'}, this.resetCurrentStepValidationState);
      this.setState({validationStateConfirmEmail: 'invalid', errorMessageConfirmEmail: 'Emails do not match. Please re-enter'}, this.resetCurrentStepValidationState);
      return;
    }
    if (email !== '') {
      this.setState({validationStateEmail: 'valid', errorMessageEmail: this.empty}, this.resetCurrentStepValidationState);
    }
    this.setState({validationStateConfirmEmail: 'valid', errorMessageConfirmEmail: this.empty}, this.resetCurrentStepValidationState);
  }

  onBlurHandlerCompany = () => {
    if (this.state.requestInformation.companyName.trim() === this.empty || this.state.requestInformation.companyName.length > 255) {
      this.setState({validationStateCompany: 'invalid', errorMessageCompany: this.errorMessageCompany}, this.resetCurrentStepValidationState);
      return;
    }
    this.setState({validationStateCompany: 'valid', errorMessageCompany: this.empty}, this.resetCurrentStepValidationState);
  }

  onBlurHandlerLocation = () => {
    if (this.state.requestInformation.location.trim() === this.empty || this.state.requestInformation.location.length > 255) {
      this.setState({validationStateLocation: 'invalid', errorMessageLocation: this.errorMessageLocation}, this.resetCurrentStepValidationState);
      return;
    }
    this.setState({validationStateLocation: 'valid', errorMessageLocation: this.empty}, this.resetCurrentStepValidationState);
  }

  onBlurHandlerPhoneNumber = () => {
    if (this.state.requestInformation.phoneNumber.length > 255) {
      this.setState({validationStatePhoneNumber: 'invalid', errorMessagePhoneNumber: this.errorMessagePhoneNumber}, this.resetCurrentStepValidationState);
      return;
    }
    this.setState({validationStatePhoneNumber: 'valid', errorMessagePhoneNumber: this.empty}, this.resetCurrentStepValidationState);
  }
  
  onBlurHandlerPostalCode = () => {
    const postalCode = this.state.requestInformation.postalCode.trim();
    if (postalCode.length > 20) {
      this.setState({validationStatePostalCode: 'invalid', errorMessagePostalCode: this.errorMessagePostalCode}, this.resetCurrentStepValidationState);
      return;
    }
    if (postalCode.match(/[\[\\\^\$\.\|\?\*\+\(\)\@\%\&\~]/)) {
      this.setState({validationStatePostalCode: 'invalid', errorMessagePostalCode: 'Special characters not allowed'}, this.resetCurrentStepValidationState);
      return;
    }
    this.setState({validationStatePostalCode: 'valid', errorMessagePostalCode: this.empty}, this.resetCurrentStepValidationState);
  }

  // Additional Questions handlers
  onChangeHandlerCondition = (opt: CommonUx.Option) => {
    const condition: string = opt.value as string;
    this.setState({requestInformation: {...this.state.requestInformation, condition}}, () => {
      if (this.state.requestInformation.condition && this.state.requestInformation.condition.trim() !== this.empty) {
        this.setState({validationStateCondition: 'valid', errroMessageCondition: this.empty}, this.resetCurrentStepValidationState);
        return;
      }
      this.setState({validationStateCondition: 'invalid', errroMessageCondition: this.errroMessageCondition}, this.resetCurrentStepValidationState);
    });
  }

  onChangeHandlerDowntime = (opt: CommonUx.Option) => {
    const downtime: string = opt.value as string;
    this.setState({requestInformation: {...this.state.requestInformation, downtime}}, () => {
      if (this.state.requestInformation.downtime && this.state.requestInformation.downtime.trim() !== this.empty) {
        this.setState({validationStateDowntime: 'valid', errorMessageDowntime: this.empty}, this.resetCurrentStepValidationState);
        return;
      }
      this.setState({validationStateDowntime: 'invalid', errorMessageDowntime: this.errorMessageDowntime}, this.resetCurrentStepValidationState);
    });
  }
  onChangeHandlerStorage = (opt: CommonUx.Option) => {
    const storage: string = opt.value as string;
    this.setState({requestInformation: {...this.state.requestInformation, storage}}, () => {
      if (this.state.requestInformation.storage && this.state.requestInformation.storage.trim() !== this.empty) {
        this.setState({validationStateStorage: 'valid', errorMessageStorage: this.empty}, this.resetCurrentStepValidationState);
        return;
      }
      this.setState({validationStateStorage: 'invalid', errorMessageStorage: this.errorMessageStorage}, this.resetCurrentStepValidationState);
    });
  }
  onChangeHandlerAwareness = (opt: CommonUx.Option) => {
    const awareness: string = opt.value as string;
    this.setState({requestInformation: {...this.state.requestInformation, awareness}}, () => {
      if (this.state.requestInformation.awareness && this.state.requestInformation.awareness.trim() !== this.empty) {
        this.setState({validationStateAwareness: 'valid', errorMessageAwareness: this.empty}, this.resetCurrentStepValidationState);
        return;
      }
      this.setState({validationStateAwareness: 'invalid', errorMessageAwareness: this.errorMessageAwareness}, this.resetCurrentStepValidationState);
    });
  }

  // Footer component handler
  onClickHandlerCancel = () => {
    this.props.dispatch({ type: 'REMOVE_BANNER', banners: [CommonUx.Banner] });
    this.resetForm();
    this.props.onClose();
  }

  onClickHandlerBack = () => {
    this.setState((prevState) => ({currentStepIndex: prevState.currentStepIndex - 1}), this.resetCurrentStepValidationState);
  }

  onClickHandlerNext = () => {
    if (!this.tryValidateForm()) {
      return;
    }
    this.setState((prevState) => ({currentStepIndex: prevState.currentStepIndex + 1}), this.resetCurrentStepValidationState);
  }

  onClickHandlerSubmit = async () => {
    if (!this.tryValidateForm() || this.state.disableSubmit) {
      return;
    }
    this.setState({disableSubmit: true});
    const uploadDetails = await UploadSparePartsDetailsService(this.props.sparePartsUploadID, this.state.requestInformation);
    this.props.dispatch({ type: 'REQUEST_INFO', requestId: uploadDetails.requestID, emailAddress: uploadDetails.contactEmail });
    this.props.dispatch({ type: 'UPLOAD_CLEAR'});
    this.props.history.push('/thankyou');
  }
}
